import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '../services/localstorage.service';
import { environment } from '../../environments/environment';
import {catchError, Observable, of, tap} from 'rxjs';
import {ICsvTemplate, ICsvTemplateResponse} from './csv-template';
import { INomeCombustivel } from '../precos-combustiveis/model/AlteracaoCombustivel';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root',
})
export class UploadplanilhaService {
  private http = inject(HttpClient);
  private localStorageService = inject(LocalStorageService);
  private userGuid = this.localStorageService.getItem('guid');


  public pegarCodCombustiveisValidos(): Observable<INomeCombustivel>{
    let url = environment.host_ctf_service + CONFIG_URLS_API.API_ConsultaListaCombustiveis + this.userGuid
    let httpOptions = {headers: {'Content-Type': 'application/json'},};

    return this.http.get<INomeCombustivel>(url,{headers: httpOptions.headers} )
      .pipe(
        tap(),
        catchError(this.handleError<INomeCombustivel>('pegarCodCombustiveisValidos', {retorno: {}} as INomeCombustivel ))
      );
  };


  public buscarDadosCsvPrecosPosto(): Observable<ICsvTemplateResponse>{
    let url = environment.host_ctf_service + CONFIG_URLS_API.API_BsucarCsvPrecosPosto
    let httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        userguid: this.userGuid,
      },
    };

    return this.http.get<ICsvTemplateResponse>(url,{headers: httpOptions.headers} )
      .pipe(
        tap(),
        catchError(this.handleError<ICsvTemplateResponse>('buscarDadosCsvPrecosPosto',  {retorno: {}} as ICsvTemplateResponse ))
      );
  };

  public uploadPlanilha(postos: ICsvTemplate[]): Observable<ICsvTemplateResponse> {
    let url = environment.host_ctf_service + CONFIG_URLS_API.API_UploadCsvPrecosPosto

    let httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        userguid: this.userGuid,
      },
    };

    return this.http
      .post<ICsvTemplateResponse>(url,JSON.stringify({cvsPrecosPostos: postos}),
        { headers: httpOptions.headers }
      )
      .pipe(
        tap(),
        catchError(this.handleError<ICsvTemplateResponse>('uploadPlanilha',  {retorno: {}} as ICsvTemplateResponse ))
      );
  }

  public buscarDadosCsvTemplate(comRedeEspecial: boolean = false): Observable<string>{
    console.log('comRedeEspecial', comRedeEspecial)
    const filePath  = comRedeEspecial ? 'assets/csvUpload/template-rede-especial.csv'  : 'assets/csvUpload/template.csv'
    return this.http.get(filePath, { responseType: 'text' });
  };

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }
}
